import {
	useEffect,
	useState,
} from 'react';
import {
	ButtonColor,
} from 'components/button';
import {
	Button,
} from 'react-bootstrap';
import {
	MdOutlineClose,
} from 'react-icons/md';
import {
	Colors,
} from 'utils/color/ColorPalette';
import PhoneInput, {
	CountryData,
} from 'react-phone-input-2';
import {
	PhoneNumberUtil,
} from 'google-libphonenumber';
import './phoneNumber.scss';

const phoneUtil = PhoneNumberUtil.getInstance();

interface PhoneNumberProps {
	phoneNumber?: string,
	onChange: (number: string) => void,
	onValidation: (val: boolean) => void,
	countryCode?: string,
}

const PhoneNumber = ({
	phoneNumber,
	onChange,
	onValidation,
	countryCode = '+47',
}: PhoneNumberProps) => {
	const [isValidated, setIsValidated] = useState<boolean>(true);
	const [number, setNumber] = useState<string>();
	const [chosenCountry, setChosenCountry] = useState(countryCode);
	const [errorMessage, setErrorMessage] = useState('');

	const validateNumber = (value: string, country: CountryData) => {
		let validity = false;
		  try {
		  const parsedNumber = phoneUtil.parse(value, country?.countryCode);
		  validity = `${value}`.length && country?.countryCode ? phoneUtil.isValidNumberForRegion(parsedNumber, country.countryCode) : false;
		  }
		// eslint-disable-next-line no-empty
		  catch (e) {}
		// ----- react-phone-input-2 is formating what it has, but not checking length (different length for different countries) ++
		setIsValidated(validity);
		setErrorMessage('');
		return validity;
	  };

	useEffect(() => {
		if (phoneNumber) {
			setNumber(phoneNumber);
		}
	}, [phoneNumber]);

	useEffect(() => {
		onValidation(isValidated);
	}, [isValidated]);

	return (
		<div className="phone-number-container">
			<div className="phone-number-box">
				<PhoneInput
					placeholder="Telefonnummer"
					onlyCountries={['se', 'dk', 'pl', 'no', 'lt', 'lv', 'ee', 'ne']}
					country="no"
					enableSearch={false}
					inputClass="phone-number-input"
					containerClass="phone-number-body"
					buttonClass="phone-number-dropdown"
					value={number}
					defaultErrorMessage={errorMessage}
					onChange={(value: any, data: CountryData) => {
						setNumber(value || '');
            			onChange(value && value.indexOf('+') === 0 ? value : '+'.concat(value) || '');
            			setChosenCountry(data?.dialCode || '+47');
            			validateNumber(value, data);
					}}
					isValid={() => isValidated}
				/>
			</div>
			<div className="phone-number-overlay">
				<Button
					className="phone-number-center-vertical"
					color={ButtonColor.NONE}
					onClick={() => {
						setNumber(chosenCountry);
						onChange(chosenCountry);
						setErrorMessage('');
						setIsValidated(false);
					}}
				>
					<MdOutlineClose size={'21px'} color={Colors.neutrals.tints.gy400.hex}/>
				</Button>
			</div>
		</div>
	);
}

export default PhoneNumber;